webpackJsonp([35783957827783],{

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(13);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _const = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Divider = function Divider(_ref) {
	    var classes = _ref.classes;
	
	    return _react2.default.createElement(
	        'div',
	        { className: classes.container },
	        _react2.default.createElement('div', { className: classes.divider })
	    );
	};
	
	var styles = {
	    container: {
	        maxWidth: function maxWidth(_ref2) {
	            var _ref2$maxWidth = _ref2.maxWidth,
	                _maxWidth = _ref2$maxWidth === undefined ? _const.layoutMaxWidth : _ref2$maxWidth;
	
	            return _maxWidth;
	        },
	        margin: '0 auto'
	    },
	    divider: {
	        width: function width(_ref3) {
	            var _ref3$width = _ref3.width,
	                _width = _ref3$width === undefined ? '50%' : _ref3$width;
	
	            return _width;
	        },
	        height: function height(_ref4) {
	            var _ref4$stroke = _ref4.stroke,
	                stroke = _ref4$stroke === undefined ? 1 : _ref4$stroke;
	            return stroke;
	        },
	        margin: '0 auto',
	        backgroundColor: function backgroundColor(_ref5) {
	            var _ref5$color = _ref5.color,
	                color = _ref5$color === undefined ? 'black' : _ref5$color;
	            return color;
	        }
	    }
	};
	
	exports.default = (0, _reactJss2.default)(styles)(Divider);
	module.exports = exports['default'];

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(13);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _gatsbyImage = __webpack_require__(36);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ImageSnippet = function ImageSnippet(_ref) {
	    var classes = _ref.classes,
	        children = _ref.children,
	        other = _objectWithoutProperties(_ref, ['classes', 'children']);
	
	    return _react2.default.createElement(
	        'div',
	        {
	            className: classes.container },
	        children
	    );
	};
	
	var styles = {
	    container: {
	        width: function width(_ref2) {
	            var _ref2$width = _ref2.width,
	                _width = _ref2$width === undefined ? '21.2rem' : _ref2$width;
	
	            return _width;
	        },
	        height: function height(_ref3) {
	            var _ref3$height = _ref3.height,
	                _height = _ref3$height === undefined ? '20rem' : _ref3$height;
	
	            return _height;
	        },
	        display: 'inline-flex',
	        flexDirection: 'column',
	        alignItems: 'center',
	        justifyContent: 'center',
	        '& h1': {
	            fontFamily: ['Noto Sans SemiBold', 'sans-serif'],
	            fontSize: '1.53rem',
	            fontWeight: 'normal',
	            marginBottom: 0
	        },
	        '& p': {
	            fontSize: '1.06rem'
	        },
	        '& a': {
	            color: '#3F3F3F',
	            textDecoration: 'none'
	        }
	    }
	};
	
	exports.default = (0, _reactJss2.default)(styles)(ImageSnippet);
	module.exports = exports['default'];

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Link = function Link(_ref) {
	    var children = _ref.children,
	        to = _ref.to,
	        other = _objectWithoutProperties(_ref, ['children', 'to']);
	
	    var internal = /^\/(?!\/)/.test(to);
	
	    if (internal) {
	        return _react2.default.createElement(
	            _gatsbyLink2.default,
	            _extends({ to: to }, other),
	            children
	        );
	    }
	    return _react2.default.createElement(
	        'a',
	        _extends({ href: to }, other),
	        children
	    );
	};
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(13);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _gatsbyImage = __webpack_require__(36);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _BackgroundImageSection = __webpack_require__(57);
	
	var _BackgroundImageSection2 = _interopRequireDefault(_BackgroundImageSection);
	
	var _Section = __webpack_require__(58);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Link = __webpack_require__(21);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ImageSnippet = __webpack_require__(226);
	
	var _ImageSnippet2 = _interopRequireDefault(_ImageSnippet);
	
	var _Divider = __webpack_require__(85);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var maxWidth = '73.85rem';
	
	var styles = {
	    buttonRect: {
	        width: '21em',
	        height: '3.67em',
	        border: 'none',
	        backgroundColor: '#43AAFF'
	    },
	    section: {
	        display: 'flex',
	        flexDirection: 'column',
	        alignItems: 'center',
	        fontSize: '1.06rem',
	        '& h4': {
	            textAlign: 'center'
	        },
	        '& p': {
	            width: '78%',
	            textAlign: 'center',
	            lineHeight: 1.3
	        }
	    },
	    diagram: {
	        width: '100%',
	        margin: '5rem 0 10rem 0'
	    },
	    sectionFeatures: {
	        display: 'flex',
	        flexWrap: 'wrap',
	        justifyContent: 'center'
	    },
	    contacts: {
	        display: 'flex',
	        flexWrqp: 'wrap',
	        justifyContent: 'center',
	        margin: '2rem 0'
	    }
	};
	
	exports.default = (0, _reactJss2.default)(styles)(function (_ref) {
	    var classes = _ref.classes,
	        data = _ref.data;
	
	    var sectionTop = _react2.default.createElement(
	        _BackgroundImageSection2.default,
	        {
	            taller: true,
	            maxWidth: maxWidth,
	            sizesBackground: data.imageBackground.childImageSharp.sizes,
	            justifyContent: 'center' },
	        _react2.default.createElement(
	            'h1',
	            null,
	            data.contents.home.title
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            data.contents.home.description
	        ),
	        _react2.default.createElement(
	            _Link2.default,
	            { to: '/downloads' },
	            _react2.default.createElement(
	                'button',
	                { className: classes.buttonRect, type: 'button' },
	                data.contents.home.download
	            )
	        )
	    );
	
	    var features = data.contents.home.feature.map(function (feature, index) {
	        var sizes = void 0;
	        data.imageFeatures.edges.some(function (edge, index) {
	            if (edge.node.name === feature.name) {
	                sizes = edge.node.childImageSharp.sizes;
	                return true;
	            }
	            return false;
	        });
	
	        return sizes ? _react2.default.createElement(
	            _ImageSnippet2.default,
	            { key: index },
	            _react2.default.createElement(_gatsbyImage2.default, { style: { width: '6.47rem' }, sizes: sizes }),
	            _react2.default.createElement(
	                'h1',
	                null,
	                feature.header
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                feature.description
	            )
	        ) : null;
	    });
	
	    var sectionFeatures = _react2.default.createElement(
	        _Section2.default,
	        { className: classes.sectionFeatures, maxWidth: maxWidth },
	        features
	    );
	
	    var sectionHowWorks = _react2.default.createElement(
	        _Section2.default,
	        { className: classes.section, maxWidth: maxWidth },
	        _react2.default.createElement(
	            'h4',
	            null,
	            data.contents.home.howworks.header
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            data.contents.home.howworks.description
	        ),
	        _react2.default.createElement(_gatsbyImage2.default, {
	            outerWrapperClassName: classes.diagram,
	            sizes: data.imageHowWorks.childImageSharp.sizes
	        })
	    );
	
	    var sectionMoving = _react2.default.createElement(
	        _BackgroundImageSection2.default,
	        {
	            taller: true,
	            maxWidth: maxWidth,
	            sizesBackground: data.imageMoving.childImageSharp.sizes,
	            justifyContent: 'center',
	            boxShadow: 'none' },
	        _react2.default.createElement(
	            'h1',
	            null,
	            data.contents.home.moving.header
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            data.contents.home.moving.description
	        ),
	        _react2.default.createElement(
	            _Link2.default,
	            { to: '/usecase' },
	            _react2.default.createElement(
	                'button',
	                { className: classes.buttonRect, type: 'button' },
	                data.contents.home.moving.usecase
	            )
	        )
	    );
	
	    var contacts = [{
	        name: "contact@onairvr.io",
	        to: "mailto:contact@onairvr.io",
	        sizes: data.imageContactMail.childImageSharp.sizes
	    }, {
	        name: "www.clicked.co.kr",
	        to: "http://clicked.co.kr",
	        sizes: data.imageContactSite.childImageSharp.sizes
	    }].map(function (contact, index) {
	        return _react2.default.createElement(
	            _ImageSnippet2.default,
	            { key: index, width: '12.4rem', height: '12rem' },
	            _react2.default.createElement(
	                _Link2.default,
	                { to: contact.to },
	                _react2.default.createElement(_gatsbyImage2.default, { sizes: contact.sizes }),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    contact.name
	                )
	            )
	        );
	    });
	
	    var sectionContact = _react2.default.createElement(
	        _Section2.default,
	        { className: classes.section, maxWidth: maxWidth },
	        _react2.default.createElement(
	            'h4',
	            null,
	            data.contents.home.contact.header
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            data.contents.home.contact.description
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: classes.contacts },
	            contacts
	        )
	    );
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        sectionTop,
	        sectionFeatures,
	        _react2.default.createElement(_Divider2.default, { maxWidth: maxWidth }),
	        sectionHowWorks,
	        sectionMoving,
	        sectionContact
	    );
	});
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-8f2aed8b7c9085d1d44f.js